import { MxSelectAgenciesFieldProp } from "@rf-l1/form/selects/MxSelectAgenciesField";
import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectAgenciesField, {
  MxFormSelectAgenciesFieldProp
} from "@rf-l2/form/select/MxFormSelectAgenciesField";

export interface MxFormL3SelectAgenciesFieldProps
  extends MxFormSelectAgenciesFieldProp {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3SelectAgenciesField = (props: MxFormL3SelectAgenciesFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormSelectAgenciesField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3SelectAgenciesField;
